
class themeRegister {

    static value = null;
    static theme = null;
    static theme_type = null;

    static setValue(value){
        themeRegister.value = value;
        try {
            sessionStorage.setItem('theme-data', JSON.stringify(themeRegister.value));
        }catch (e) {}
    }

    static setItem(key, value){
        try {
            themeRegister.value[key] = value;
            sessionStorage.setItem('theme-data', JSON.stringify(themeRegister.value));
        }catch (e) {}
    }

    static setTheme(theme){
        themeRegister.theme = theme;
        try {
            sessionStorage.setItem('theme', themeRegister.theme);
        }catch (e) {}
    }

    static setThemeType(type){
        themeRegister.theme_type = type;
        try {
            sessionStorage.setItem('theme_type', themeRegister.theme_type);
        }catch (e) {}
    }

    static getValue(){
        try {
            if(sessionStorage.getItem('theme-data')){
                let value =  JSON.parse(sessionStorage.getItem('theme-data'));
                return value;
            }else{
                return themeRegister.value;
            }
        }catch (e) {
            return themeRegister.value;
        }
    }

    static getTheme(){
        try {
            if(sessionStorage.getItem('theme')){
                let theme = sessionStorage.getItem('theme');
                return theme;
            }else{
                return themeRegister.theme;
            }
        }catch (e) {
            return themeRegister.theme;
        }
    }

    static getThemeType(){
        try {
            if(sessionStorage.getItem('theme_type')){
                let theme = sessionStorage.getItem('theme_type');
                return theme;
            }else{
                return themeRegister.theme_type;
            }
        }catch (e) {
            return themeRegister.theme_type;
        }
    }

    static remove(){
        try {
            sessionStorage.removeItem('theme');
            sessionStorage.removeItem('theme-data');
            sessionStorage.removeItem('theme_type');
        }catch (e) {}
        themeRegister.value = null;
        themeRegister.theme = null;
        themeRegister.theme_type = null;
    }

}

export {themeRegister}


// WEBPACK FOOTER //
// ./src/services/themeRegister.js